import React from 'react';

export function PulseLogo({ size = 'md' }) {
  const sizes = { sm: { text1: 20, text2: 20, dot: 8 }, md: { text1: 28, text2: 28, dot: 10 }, lg: { text1: 40, text2: 40, dot: 14 } };
  const s = sizes[size] || sizes.md;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <span style={{ fontSize: s.text1, fontWeight: 800, color: 'var(--pp-accent)', letterSpacing: '-1px', lineHeight: 1 }}>PROFIT</span>
      <span style={{ fontSize: s.text2, fontWeight: 800, color: 'var(--pp-primary)', letterSpacing: '-1px', lineHeight: 1 }}>PULSE</span>
    </div>
  );
}

export function PlatformLogo({ platform, size = 24 }) {
  const LOGOS = {
    tradelocker: { text: 'TL', color: '#FF6B6B', bg: '#FF6B6B20' },
    metatrader: { text: 'MT', color: '#00B4D8', bg: '#00B4D820' },
    tradovate: { text: 'TV', color: '#00FF94', bg: '#00FF9420' },
    matchtrader: { text: 'MX', color: '#FFB000', bg: '#FFB00020' },
    other: { text: '??', color: '#A1A1AA', bg: '#A1A1AA20' },
  };
  const logo = LOGOS[platform] || LOGOS.other;
  return (
    <div style={{ width: size, height: size, background: logo.bg, border: `1px solid ${logo.color}40`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.37, fontWeight: 700, color: logo.color, fontFamily: 'monospace', flexShrink: 0 }}>
      {logo.text}
    </div>
  );
}

export function TradeToast({ visible, type, symbol, action, message, subMessage, onDismiss }) {
  if (!visible) return null;
  const isPositive = type === 'success' || (action && action.toLowerCase() === 'buy');
  const color = isPositive ? 'var(--pp-success)' : type === 'error' ? 'var(--pp-error)' : 'var(--pp-accent)';
  return (
    <div style={{ position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: 'var(--pp-overlay)', border: `1px solid ${color}40`, padding: '12px 16px', minWidth: 280, display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.4)', animation: 'fade-in 200ms ease' }}>
      <div style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        {symbol && <span className="mono" style={{ fontSize: 13, fontWeight: 700, color: 'var(--pp-text)' }}>{action?.toUpperCase()} {symbol}</span>}
        <p style={{ margin: 0, fontSize: 12, color: 'var(--pp-text-2)' }}>{message}</p>
        {subMessage && <p style={{ margin: 0, fontSize: 11, color: 'var(--pp-text-3)' }}>{subMessage}</p>}
      </div>
      <button onClick={onDismiss} style={{ background: 'none', border: 'none', color: 'var(--pp-text-3)', cursor: 'pointer', padding: 4 }}>✕</button>
    </div>
  );
}

export function LoadingScreen({ message = 'LOADING...' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--pp-bg)' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <div style={{ width: 32, height: 32, border: '2px solid var(--pp-primary)', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        <p className="section-label">{message}</p>
      </div>
    </div>
  );
}

export function MetricBox({ label, value, color }) {
  return (
    <div style={{ flex: 1, textAlign: 'center', padding: '12px 8px' }}>
      <div className="mono" style={{ fontSize: 15, fontWeight: 600, color: color || 'var(--pp-text)' }}>{value}</div>
      <div className="section-label" style={{ marginTop: 4, fontSize: 8 }}>{label}</div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const styles = {
    active: 'badge-success',
    connected: 'badge-success',
    connecting: 'badge-warning',
    pending: 'badge-warning',
    error: 'badge-error',
    deploying: 'badge-warning',
    backtesting: 'badge-warning',
    pending_proxy: 'badge-warning',
  };
  return (
    <span className={styles[status] || 'badge-accent'}>
      {(status || 'UNKNOWN').toUpperCase().replace('_', ' ')}
    </span>
  );
}
